var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { mergeProps, useFocusRing } from 'react-aria';
import { enhancerStyle } from './styles';
function Enhancer(_a) {
    var { children, size = 'medium' } = _a, restProps = __rest(_a, ["children", "size"]);
    const { focusProps, isFocusVisible } = useFocusRing();
    return (_jsx("button", Object.assign({ type: "button" }, mergeProps(focusProps, restProps), { css: enhancerStyle({ isFocusVisible }) }, { children: children.props.size != null
            ? children
            : cloneElement(children, {
                // Handle large buttons having medium sized icons by default
                size: size === 'large' ? 'medium' : size,
            }) })));
}
export default Enhancer;
